module.exports = __webpack_public_path__ + "static/img/dy2-1.889ea10.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/dy2-1.png
// module id = 953
// module chunks = 0